const TemplatePreview = ({ formData, variableSamples }) => {
  const { header, bodyText, footer, buttons } = formData;
  
  // Replace variables with samples in the preview
  const renderBodyText = () => {
    if (!bodyText) return "No message content";
    
    let processedText = bodyText;
    variableSamples.forEach((sample, index) => {
      const variable = `{{${index + 1}}}`;
      processedText = processedText.replace(
        new RegExp(variable, 'g'), 
        `<span class="cx-template-variable-highlight">${sample || variable}</span>`
      );
    });
    
    return processedText;
  };

  return (
    <div className="cx-template-preview-card">
      <div className="cx-template-preview-header">
        <h2>Preview</h2>
        <p>Live preview of your template message.</p>
      </div>

      <div className="cx-template-preview-body">
        <div className="cx-template-preview-container">
          <div className="cx-template-whatsapp">
            <div className="cx-template-whatsapp-header">
              <div className="cx-template-business-info">
                <div className="cx-template-avatar"></div>
                <div className="cx-template-business-details">
                  <div className="cx-template-business-name">
                    Business Name
                  </div>
                  <div className="cx-template-business-status">
                    WhatsApp Business
                  </div>
                </div>
              </div>
            </div>
            
            <div className="cx-template-message-container">
              <div className="cx-template-message-bubble">
                {header.type !== "NONE" && (
                  <div className="cx-template-message-header">
                    {header.type === "TEXT" && (
                      <strong>{header.text || "Header"}</strong>
                    )}
                    {header.type === "IMAGE" && (
                      <img
                        src={header.url || "https://via.placeholder.com/300x150"}
                        alt="Header"
                        className="cx-template-header-media"
                        onError={(e) => e.target.src = "https://via.placeholder.com/300x150"}
                      />
                    )}
                    {header.type === "VIDEO" && (
                      <div className="cx-template-header-media cx-template-video-placeholder">
                        <i className="bi bi-play-circle-fill"></i>
                        <p>Video Preview</p>
                      </div>
                    )}
                    {header.type === "DOCUMENT" && (
                      <div className="cx-template-document-preview">
                        <i className="bi bi-file-earmark-text"></i>
                        <div className="cx-template-document-info">
                          <div className="cx-template-document-name">
                            Document.pdf
                          </div>
                          <div className="cx-template-document-size">
                            125 KB
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                
                <div 
                  className="cx-template-message-body"
                  dangerouslySetInnerHTML={{ __html: renderBodyText() }}
                />
                
                {footer && (
                  <div className="cx-template-message-footer">{footer}</div>
                )}
                
                {buttons.length > 0 && (
                  <div className="cx-template-message-buttons">
                    {buttons.map((btn, i) => (
                      <div key={i} className="cx-template-whatsapp-button">
                        {btn.text}
                      </div>
                    ))}
                  </div>
                )}
                
                <div className="cx-template-message-time">
                  {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="cx-template-preview-note">
          <i className="bi bi-info-circle me-2"></i>
          This is an approximate preview. Actual appearance may vary in
          WhatsApp.
        </div>
      </div>
    </div>
  );
};

export default TemplatePreview;